import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { TalentHappyPathDataService } from "../../shared/service/talent-happy-path-data-service";
import { QuickApplyApiService } from "../quick-apply-api.service";
import { TalentHappyPathAuthService } from "../../shared/service/talent-happy-path-auth.service";
import { TranslateService } from "@ngx-translate/core";
import { QuickApplyWorkflowService } from "../quick-apply-workflow.service";

@Component({
  selector: 'app-quick-apply-container',
  standalone: false,
  templateUrl: './quick-apply-container.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './quick-apply-container.component.scss'
})
export class QuickApplyContainerComponent implements OnInit {
  posting: PostingInfo;
  isQuickApplyLoaded: boolean = false;
  isGeneralApplication = false;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private quickApplyService: QuickApplyApiService,
              private talentHappyPathDataService: TalentHappyPathDataService,
              private authService: TalentHappyPathAuthService,
              private translate: TranslateService,
              private workflowService: QuickApplyWorkflowService) {
  }


  async ngOnInit(): Promise<void> {

    if (this.talentHappyPathDataService.isGeneralApplication) {
      this.isQuickApplyLoaded = true;
      if (!this.authService.isAuthenticated()) {
        await this.workflowService.navigateToState('start', {}, {
          relativeTo: this.route.parent,
          queryParamsHandling: "preserve",
          skipLocationChange: true
        });
      } else {
        await this.workflowService.navigateToState('submit', {}, {
          relativeTo: this.route.parent,
          skipLocationChange: true
        })
      }
      return;
    }

    this.talentHappyPathDataService.urlHasPostingId = this.route.snapshot.paramMap.has("postingId");
    this.authService.reload();
    if (this.talentHappyPathDataService.urlHasPostingId) {
      const postingId = String(this.route.snapshot.paramMap.get("postingId"));
      const isFromInviteLink = this.router.url.includes('/invite')

      this.quickApplyService.readPostingInfo(postingId).subscribe(async posting => {
        if (posting) {
          this.talentHappyPathDataService.postingId = posting.jobPostingId;
          this.talentHappyPathDataService.postingInfo = posting;
          this.isQuickApplyLoaded = true;

          this.posting = posting;
          if (!posting.isPosted && !this.talentHappyPathDataService.goToVmsSub) {
            this.router.navigateByUrl('/job-posting-closed', {skipLocationChange: true});
          }
          // auth guard for all children components
          else if (this.authService.isAuthenticated() && !this.talentHappyPathDataService.goToVmsSub){
            if(isFromInviteLink) {
              this.saveCandidateInviteLinkFrom();
            }
            await this.workflowService.navigateToState('submit', {} , { relativeTo: this.route.parent, queryParamsHandling: "preserve" });
          }
          else if (isFromInviteLink) {
            this.saveCandidateInviteLinkFrom();
            await this.workflowService.navigateToState('invite', {} , { relativeTo: this.route.parent, queryParamsHandling: "preserve" });
          }
          else {
            await this.workflowService.navigateToState('start', {} , { relativeTo: this.route.parent, queryParamsHandling: "preserve" });
          }
        } else {
          this.isQuickApplyLoaded = true;
          this.router.navigateByUrl('/job-posting-closed', {skipLocationChange: true});
        }
      });
    } else { // If no posting ID is in the URL, then it is a login, and the URL should read that way.
      await this.workflowService.navigateToState('login', {} , { relativeTo: this.route.parent, queryParamsHandling: "preserve" });
    }
  }

  saveCandidateInviteLinkFrom() {
    let referrerURL = document.referrer;
    let marketingData = <MarketingTrackingInfo>{};
    marketingData.utmMedium = "Invite";
    marketingData.utmCampaign = "Candidate Invite Link";
    marketingData.utmContent = String(this.posting.jobPostingId);

    if(referrerURL == null || referrerURL == '') {
      marketingData.utmSource = this.translate.instant('talent-happy-path.quick-apply.invite-page.other');
      this.talentHappyPathDataService.candidateInviteLinkFrom = this.translate.instant('talent-happy-path.quick-apply.invite-page.other');
    }
    else {
      marketingData.utmSource = referrerURL;
      this.talentHappyPathDataService.candidateInviteLinkFrom = this.getDomainFromUrl(referrerURL);
    }

    this.talentHappyPathDataService.marketingData = marketingData;
  }

   getDomainFromUrl(url: string): string | null {
      try {
        let hostname = new URL(url).hostname;
        const parts = hostname.split('.');

        if (parts.length >= 2) {
          hostname = parts[parts.length - 2];
        }

        return hostname.charAt(0).toUpperCase() + hostname.slice(1);
      } catch (e) {
        return null;
      }
  }

}
